import {combineReducers} from 'redux'
import notifReducer from './notif'

export default combineReducers({
    notif: notifReducer,
})